module.exports = __webpack_public_path__ + "img/course-title-icon.76f3f5c6.svg";